<template>
  <div class="map-demo-container">
    <!-- <h2>天地图地址定位组件示例</h2> -->
    <TianDiTuMap
      :initial-lng="initialLocation.lng"
      :initial-lat="initialLocation.lat"
      :initial-address="initialAddress"
      @location-change="handleLocationChange"
      @address-change="handleAddressChange"
      ref="mapComponent"
    />

    <div class="actions">
      <el-button @click="getLocationInfo">获取当前位置信息</el-button>
      <el-button @click="setCustomLocation">设置自定义位置</el-button>
      <el-button @click="setCustomAddress">设置自定义地址</el-button>
    </div>

    <div class="location-info" v-if="locationInfo">
      <p>
        <strong>当前位置信息：{{ locationInfo.address }}</strong>
      </p>
      <p>地址：{{ locationInfo.address }}</p>
      <p>经度：{{ locationInfo.lng }}</p>
      <p>纬度：{{ locationInfo.lat }}</p>
    </div>
  </div>
</template>

<script>
import TianDiTuMap from "@/components/map/TianDiTuMap.vue";

export default {
  components: {
    TianDiTuMap,
  },
  data() {
    return {
      initialLocation: {
        lng: 115.86,
        lat: 28.69,
      },
      initialAddress: "南昌市",
      locationInfo: null,
    };
  },
  methods: {
    handleLocationChange(location) {
      console.log("位置已更新:", location);
      this.locationInfo = location;
    },

    handleAddressChange(location) {
      console.log("地址已更新:", location);
      this.locationInfo = location;
    },

    getLocationInfo() {
      // 通过ref获取地图组件实例的当前位置信息
      const mapComponent = this.$refs.mapComponent;
      this.locationInfo = mapComponent.getLocationInfo();
    },

    setCustomLocation() {
      // 设置自定义位置示例
      const mapComponent = this.$refs.mapComponent;
      // 南昌双子塔
      const result = mapComponent.setLocation(115.86, 28.69);
      console.log("设置位置结果:", result);
    },

    setCustomAddress() {
      // 设置自定义地址示例
      const mapComponent = this.$refs.mapComponent;
      mapComponent.setAddress("九江市九江学院主校区");
    },
  },
};
</script>

<style scoped>
.map-demo-container {
  padding: 20px;
}

.actions {
  margin: 15px 0;
}

.location-info {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  background-color: #f9f9f9;
}
</style>